import { __isLocalhost } from './debug'

export const _timing = {
  micro_apps: {}
} as Record<string, number> & { micro_apps: Record<string, Record<string, number>> }

const DEFAULT_TIMEOUTS = {
  microAppEntryLoadTimeout: 10000, // 10s
  microAppInitTimeout: 10000, // 10s
  microAppTsgLoadTimeout: 15000, // 15s
}
export const _timeouts = { ...DEFAULT_TIMEOUTS }

export type NetworkSpeed = 'fast' | 'slow' | 'abandon' | ''
export const _performance = {
  speed: '' as NetworkSpeed,
  timeouts: _timeouts,
  timing: _timing,
}

const updateTimeouts = (speed: NetworkSpeed) => {
  switch (speed) {
    case 'slow':
      console.warn('slow network detected, increase micro-app load timeouts, user may see page loading longer than usual')
      _timeouts.microAppEntryLoadTimeout = 30000
      _timeouts.microAppInitTimeout = 15000
      _timeouts.microAppTsgLoadTimeout = 30000
      break
    case 'abandon':
      console.error('very slow network detected, remove micro-app load timeouts, user may see blank page or spinner forever')
      _timeouts.microAppEntryLoadTimeout = 0
      _timeouts.microAppInitTimeout = 0
      _timeouts.microAppTsgLoadTimeout = 0
      break
    default:
      Object.assign(_timeouts, DEFAULT_TIMEOUTS)
  }
}

const currentScriptLoadedFallback = Date.now()
export const measureNetworkCondition = __isLocalhost ? () => {
  const override = localStorage._timeout_speed_override
  if (override) {
    _performance.speed = override
    updateTimeouts(_performance.speed)
  }
  return _performance.speed
} : () => {
  let pageLoadTime = 0
  let sciprtLoadTime = 0
  if (performance?.getEntriesByType) {
    const perfEntry = performance.getEntriesByType('navigation')?.[0] as PerformanceNavigationTiming | undefined
    if (perfEntry) {
      pageLoadTime = Math.max(perfEntry.domInteractive, perfEntry.domContentLoadedEventEnd, perfEntry.domContentLoadedEventStart)
    }
    const resEntries = performance.getEntriesByType('resource') as PerformanceResourceTiming[]
    if (resEntries.length) {
      sciprtLoadTime = resEntries.reduce((max, entry) => {
        if (entry.transferSize === 0) { // ignore cached
          return max
        }
        const isJsCss = entry.initiatorType ? ['script', 'link', 'css'].includes(entry.initiatorType) : /\.(?:js|css)$/i.test(entry.name)
        if (!isJsCss && !entry.name.includes('pendo')) {
          return max
        }
        const respStatus = (entry as any).responseStatus as number | undefined
        if (!respStatus || respStatus === 200) {
          max = Math.max(max, entry.duration)
        }
        return max
      }, 0)
    }
  }
  else if (performance.timing?.navigationStart) {
    const { navigationStart, domLoading, domInteractive, domContentLoadedEventEnd, domContentLoadedEventStart } = performance.timing
    const ends = Math.max(navigationStart, domLoading, domInteractive, domContentLoadedEventEnd, domContentLoadedEventStart)
    if (ends > navigationStart) {
      pageLoadTime = ends - navigationStart
    }
    sciprtLoadTime = currentScriptLoadedFallback - (domContentLoadedEventEnd || domContentLoadedEventStart || navigationStart)
  }
  else {
    console.error('cannot measure loading speed as performance api is not available')
  }
  pageLoadTime = Math.round(pageLoadTime)
  _performance.speed = localStorage._timeout_speed_override || (pageLoadTime > 1100 || sciprtLoadTime > 1500 ? 'abandon' :
    pageLoadTime > 600 || sciprtLoadTime > 500 ? 'slow' : 'fast')
  sessionStorage.sparky_network_speed = _performance.speed
  updateTimeouts(_performance.speed)
  return _performance.speed
}

export default _performance
